var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowBanner)?_c('banner',{attrs:{"color-scheme":"primary","banner-message":_vm.bannerMessage,"href-link":"https://github.com/dropechat/dropechat/releases","href-link-text":_vm.$t('GENERAL_SETTINGS.LEARN_MORE'),"has-close-button":""},on:{"close":_vm.dismissUpdateBanner}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }